import React from 'react';
import { mount, lazy } from 'navi';

export const routes = mount({
    '/v2': mount({
        '/catalog': lazy(() => import('./catalog')),
        '/activity': lazy(() => import('./activity')),
        '/admin': lazy(() => import('./admin')),
        '/updates': lazy(() => import('./updates')),
        '/marketing': lazy(() => import('./marketing')),
        '/libraries': lazy(() => import('./libraries')),
        '/signup': lazy(() => import('./signup')),
    }),
});
